import React from 'react';

export const HeroPreviewCard: React.FC = () => {
  return (
    <div className="company-hero-preview" aria-hidden="true">
      <div className="company-hero-preview-card">
        <div className="company-hero-preview-header">
          <span className="company-hero-preview-channel">
            <span>ER</span>
            <span className="company-hero-preview-channel-arrow">→</span>
            <span>ICU</span>
          </span>
          <span className="company-hero-preview-live">
            <span className="company-hero-preview-live-dot" />
            Live
          </span>
          <span className="company-hero-preview-time">2:31 PM</span>
        </div>

        <div className="company-hero-preview-messages">
          <div className="company-hero-preview-message company-hero-preview-message-received">
            <div className="company-hero-preview-avatar company-hero-preview-avatar-1">MH</div>
            <div className="company-hero-preview-bubble">
              <div className="company-hero-preview-meta">
                <strong>Dr. M. Hassan</strong>
                <span>Emergency Medicine</span>
              </div>
              <p>Bed 12 transfer ready — vitals stable, awaiting ICU receipt.</p>
            </div>
          </div>

          <div className="company-hero-preview-message company-hero-preview-message-sent">
            <div className="company-hero-preview-avatar company-hero-preview-avatar-2">KR</div>
            <div className="company-hero-preview-bubble company-hero-preview-bubble-sent">
              <div className="company-hero-preview-meta">
                <strong>K. Reyes, RN</strong>
                <span>ICU Charge</span>
              </div>
              <p>Receiving. Bed 4 prepped — ETA on arrival?</p>
            </div>
          </div>

          <div className="company-hero-preview-typing">
            <div className="company-hero-preview-avatar company-hero-preview-avatar-1">MH</div>
            <div className="company-hero-preview-typing-bubble">
              <span className="company-hero-preview-typing-dot" />
              <span className="company-hero-preview-typing-dot" />
              <span className="company-hero-preview-typing-dot" />
            </div>
            <span className="company-hero-preview-typing-label">Dr. Hassan is typing…</span>
          </div>
        </div>

        <div className="company-hero-preview-badge">
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="20 6 9 17 4 12" />
          </svg>
          Audit-logged
        </div>
      </div>
    </div>
  );
};

export default HeroPreviewCard;
